import KeywordTaskList from './KeywordTaskList.component';

export default KeywordTaskList;
